import { memo } from "react"
import { FeedCurve } from "../../../../Services"
import { fonts, frames } from "../../../../Styles"
import { useFeedCurveContext } from "../../../FeedCurves/_FeedCurves/feedCurveContext";

const LabelsMilestones = memo(({ feedCurve }: { feedCurve: FeedCurve }) => {
  const context = useFeedCurveContext();  
  const selectedMilestone = context?.state?.milestone?.selectedMilestone;
  const dispatch = context?.dispatch;

  return (
    <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: "5px", width: "fit-content"}}>
      {[...(feedCurve.milestones ?? [])].sort((milestoneA, milestoneB) => milestoneA.milestoneIndex - milestoneB.milestoneIndex).map((feedcurveMilestone, index) => {
        const _isHovered = selectedMilestone === feedcurveMilestone

        return (
          <frames.Label
            key={index}
            $textLabel
            $isHovered={_isHovered}
            onMouseEnter={() => dispatch({ milestone: { selectedMilestone: feedcurveMilestone } })}
            onMouseLeave={() => dispatch({ milestone: { selectedMilestone: undefined} })}
            style={{ display: "flex", gap: "2px", alignItems: "center" }}
          >
            <p style={{ ...fonts.header }}>{`M${index + 1}: `}</p>
            <p style={{ ...fonts.paragraph, lineHeight: "1" }}>{`${feedcurveMilestone.name}`}</p>
          </frames.Label>
        )
      })}
    </div>
  )
})

export default LabelsMilestones